import React, { useState, useRef } from "react"
import useSWR, { mutate } from 'swr'
import { Link } from "react-router";

import axios from 'axios'
import fetch from 'isomorphic-unfetch'
const fetcher = url => fetch(url).then(r => r.json())


function GroupsIndex(props){
  const { data, error } = useSWR('/api/groups', fetcher)
  const [showForm, setShowForm] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [title, setTitle] = useState('')

  const titleInput = useRef(null);
  const [showJSON, setShowJSON] = useState(false)
  function toggleShowJSON(){
    setShowJSON(!showJSON)
  }

  const changeTitle = (e) => {
    setTitle(e.target.value)
  }

  function toggleForm(){
    console.log("running toggle form")
    setShowForm(!showForm)
  }

  function dontToggle(event){
    event.stopPropagation()
  }

  const submitForm = () => {
    if(title === ''){
      setErrorMessage('Fields not set')
    } else {
      setErrorMessage('')
      const formData = new FormData()
      formData.append('title', title)

      const endpoint = '/api/groups'
      axios.post(endpoint, formData, {}).then(res => {
        console.log(res)
        // reset the form/reload the versions list
        setTitle('')
        titleInput.value = null

        setErrorMessage('')
        setShowForm(false)

        // tell swr to refresh any data using this endpoint
        mutate('/api/groups')
      }).catch(err => {
        console.log(err)
      })
    }
  }


  // TODO: turn these into components
  if (error) return <div className="loading"><p>Failed to load. The server is probably down.</p></div>
  if (!data) return <div className="loading"><p>Loading...</p></div>

  return(
    <div>
      <h1>Groups <button className="inline-control-small inline-right" onClick={toggleForm}><span>+</span></button></h1>

      <div className="form" style={{ display: (showForm ? "block" : "none")}}  onClick={toggleForm}>
        <div className="form-modal" onClick={dontToggle} >
          <h3>New Group</h3>
          <p className='error-message'><b><i>{errorMessage}</i></b></p>
          <p><input ref={titleInput} type="text" value={title} placeholder="New Group" name="title" onChange={changeTitle}></input></p>
          <p><input type='submit' value='Save' onClick={submitForm} /></p>
        </div>
      </div>

      <div className="grid">
        <GroupList groups={data}/>
      </div>

      <div>
        <h1>JSON OUTPUT <button className="inline-control-small" onClick={toggleShowJSON}><span>{showJSON ? "hide" : "show"}</span></button></h1>
        <pre className={showJSON ? "" : "hidden"}>{JSON.stringify(data, null, 3)}</pre>
      </div>

    </div>
  )

}


function GroupList(props){
  // map the data to JSX
  const groups = props.groups.map(group => (
    <Link to={ "/groups/" + group.id } className="grid-item" key={group.id} >
      <h3>{group.title}</h3>
    </Link>
  ))

 return (
   <>
     {groups}
   </>
 )
}

export default GroupsIndex;
